var GdsBubbleBadgeStyle;
(function (GdsBubbleBadgeStyle) {
  GdsBubbleBadgeStyle["Default1"] = "Default1";
  GdsBubbleBadgeStyle["Default2"] = "Default2";
  GdsBubbleBadgeStyle["Status"] = "Status";
  GdsBubbleBadgeStyle["Alert"] = "Alert";
})(GdsBubbleBadgeStyle || (GdsBubbleBadgeStyle = {}));

export { GdsBubbleBadgeStyle as G };

